import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services';


@Component({
  selector: 'app-dmd-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
  }

  logout() { // logout
    this.authService.SignOut();
  }

}
